<template>
  <!--  用户管理页面-->
  <div>
    <div class="setting-container">
      <div
        class="setting-room"
        @mouseover="isShowEdit = true"
        @mouseleave="isShowEdit= false"
      >
        <menu-select
          v-if="menuList.length"
          :menu-list="menuList"
        />
        <div v-show="isShowEdit" class="option-button">
          <div class="option-bg" @click="showNewRoom= true">
            <i class="el-icon-plus"/>
          </div>
          <div class="option-bg" @click="showDeleteRoom= true">
            <i class="el-icon-minus"/>
          </div>
        </div>
      </div>
      <div class="setting">
        <div class="setting-search">
          <span class="name">姓名：</span>
          <el-input
            v-model="name"
            placeholder="请输入内容"
          />
          <el-button @click="checkPerson(true)">搜索</el-button>
          <el-button @click="checkPerson(false)">重置</el-button>
          <el-button
            @click="addNewUser"
          >新建
          </el-button>
        </div>
        <div class="setting-table">
          <el-table border :data="tableData" style="width: 100%">
            <el-table-column
              align="center"
              prop="realName"
              label="姓名"
              width="120"
            />

            <el-table-column
              align="center"
              prop="Department"
              label="科窒"
              width="120"
            />
            <el-table-column
              align="center"
              prop="group"
              label="小组"
              width="120"
            />
            <el-table-column
              align="center"
              prop="atype"
              label="角色"
              width="120"
            />
            <el-table-column
              align="center"
              prop="account"
              label="账号"
              width=""
            />
            <el-table-column
              align="left"
              prop=""
              label="操作"
            >
              <template #default="{row}">
                <div v-if="row.id" class="button-group">
                  <el-button type="text" @click="handleDelete(row)">
                    删除
                  </el-button>
                  <el-button type="text" @click="handleReset(row)">
                    重置密码
                  </el-button>
                  <el-button
                    type="text"
                    @click="handleEdit(row)"
                  >修改信息
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="setting-pagination">
          <el-pagination
            small
            layout="prev, pager, next"
            :total="total"
            :page-size="pagination.howPage"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>

    <many-dialog
      :form-title="formTitle"
      :change-user-data="changeUserData"
      :show-add-new-user-dialog="addNewUserDialog"
      :show-two-option-dialog="twoOptionDialog"
      :action-row-data="actionRowData"
      :show-new-room="showNewRoom"
      :show-delete-room="showDeleteRoom"
      @getDepartmentGroupOptions="getDepartmentGroupOptions"
      @closeTwoOptions="twoOptionDialog=false"
      @closeDialog="addNewUserDialog = false"
      @closeNewRoom="showNewRoom=false"
      @closeDeleteRoom="showDeleteRoom= false"
    />
  </div>
</template>

<script>
import { dealAllUser } from "@/api/user";
import { showWindowMessage } from "@utils/notification";
import { mapState } from "vuex";
import MenuSelect from "@components/setting/UserSetting/MenuSelect";
import ManyDialog from "@components/setting/UserSetting/ManyDialog";
import userSetting from "@components/setting/UserSetting/userSetting";

export default {
  name: "UserSetting",
  components: {
    MenuSelect,
    ManyDialog,
  },
  mixins: [userSetting],
  data() {
    return {
      menuList: [],
      changeUserData: null, // 修改用户信息数据
      formTitle: "",
      addNewUserDialog: false, // 打开添加新用户弹窗
      twoOptionDialog: false,
      actionRowData: {},
      showErrorPhone: "",
      showErrorEmail: "",
      addUserDialog: false, // 打开新加用户弹窗
      showDelete: false,
      id: "", // 删除用户的id
      department: "", // 部门
      inputName: "", //
      inputAccount: "",
      inputEmail: "",
      inputPhone: "",
      name: "", // 查找的用户名
      tableData: [],
      // 分页相关
      pagination: {
        howPage: 6, // 一页几张
        page: 1, // 要第几页
        type: "search",
        name: ""
      },
      total: null, // 所有用户个数
      isShowEdit: false,
      dealUser: "", // 正在操作的用户名
      showReset: false,
      showNewRoom: false,
      showDeleteRoom: false,

    };
  },
  computed: {
    ...mapState({
      hospitalInfo: "hospitalInfo",
      userInfo: "userInfo",
      hospitalID: "hospitalID",
    })
  },
  mounted() {
    this.getUser();
  },
  methods: {
    /**
     * 子组件已经获得科室那些, 传过来
     * @param {Array} groups - 科室列表
     * */
    getDepartmentGroupOptions(groups) {
      this.menuList = groups;
    },
    addNewUser() {
      this.addNewUserDialog = true;
      this.formTitle = "新增用户";
      this.changeUserData = null;
    },
    // 查询用户
    checkPerson(type) {
      if (!type) {
        this.name = "";
      }
      this.pagination.name = this.name;
      // 恢复默认情况
      this.getUser();
    },
    // 处理点击页面后的分页展示
    handleCurrentChange(e) {
      this.pagination.page = e;
      this.getUser();
    },
    // 填满表格
    fillDrugsData(table, times) {
      for (let n = 0; n < times; n++) {
        const row = {};
        table.push(row);
      }
    },
    // 获得分页信息
    async getUser() {
      let res;
      try {
        res = await dealAllUser(this.pagination);
      } catch (e) {
        showWindowMessage(3, "获取用户信息失败, 服务器错误", this);
      }
      const { all_counts, code, data } = res;
      if (code !== 200) {
        showWindowMessage(3, "获取用户信息失败", this);
        return;
      }
      data.forEach(item => {
        item.atype = item.type;
      });
      const len = data.length;
      this.total = all_counts;
      this.fillDrugsData(
        data,
        12 - len > 0 ? 12 - len : 0
      );
      this.tableData = data;
    },

    handleDelete(row) {
      this.twoOptionDialog = true;
      this.actionRowData = {
        ...row,
        dealUserAction: "删除",
        dealUserDetail: "请问您是否继续强制删除该用户？",
      };
    },
    handleReset(row) {
      this.twoOptionDialog = true;
      this.actionRowData = {
        ...row,
        dealUserAction: "重置",
        dealUserDetail: "的密码，重置密码为联系方式的后6位，请问是否继续？",
      };
    },
    // 修改用户
    handleEdit(row) {
      this.formTitle = "修改信息";
      const clonedRow = JSON.parse(JSON.stringify(row)); // 深复制，避免修改原始数据
      this.changeUserData = {
        ...clonedRow, // 使用展开运算符将已经克隆的行数据与下面的属性合并
        Utype: row.type,
        Department: row.department,
        type: "information",
      };
      this.addNewUserDialog = true;
    }
  },
};
</script>

<style scoped lang="scss">
.setting-container {
  display: flex;
  margin-top: 24px;
}

.setting {
  width: 1272px;
  height: 720px;
  background: #FBFBFB;
  border-radius: 10px;
  margin-left: 20px;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 24px;
}

.setting-search ::v-deep {
  font-size: 16px;
  color: #666666;
  margin-bottom: 24px;

  .name {
  }

  .el-input {
    width: auto;
    margin-left: 20px;

    .el-input__inner {
      width: 120px;
      height: 32px;
      border: 1px solid #999999;
      border-radius: 10px;
    }
  }

  .el-button {
    width: 64px;
    height: 32px;
    min-height: 16px;
    border: 1px solid #2AA5E3;
    border-radius: 6px;
    font-size: 16px;
    color: #2AA5E3;
    padding-top: 8px;
    padding-left: 16px;
    margin-left: 48px;
  }

  .el-button:nth-child(3) {
    float: right;
    background: #2AA5E3;

    color: #FBFBFB;
  }
}

::v-deep {
  .el-table {
    // 整个表格圆角
    border-radius: 10px;
    font-size: 14px;

    // 表头
    .el-table__header {
      tr {
        height: 46px;
      }

      th {
        background: #F4F4F4;
        color: #666666;
        border-right: transparent;
      }
    }

    // 表格内容
    .el-table__body {
      tr {
        height: 46px;
      }

      td {
        // 表格的body的padding设置为0, 让height生效
        padding: 0;
        color: #333333;
        border-right: transparent;
      }

      .el-button {
        font-size: 14px;
        color: #2AA5E3;
      }
    }
  }
}

.setting-pagination ::v-deep {
  display: flex;
  justify-content: flex-end;

  .el-pager {
    li.active {
      color: #0C618B;
    }

    li:hover {
      color: #0C618B;
    }
  }

  .el-pagination {
    color: #999999;
  }
}

.setting-room {
  width: 320px;
  height: 720px;
  background: #FBFBFB;
  border-radius: 10px;

  position: relative;

  .option-button {
    display: flex;
    position: absolute;
    right: 0;
    bottom: 0;

    .option-bg {
      width: 36px;
      height: 36px;
      background: #FBFBFB;
      box-shadow: 0 0 8px 0 rgba(127, 147, 166, 0.4000);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 16px;
      margin-bottom: 16px;
      cursor: pointer;
    }

    .el-icon-plus {
      color: #2AA5E3;
    }
  }
}

.button-group {
  .el-button {
    margin-right: 55px
  }
}

.deal-user {
  color: #2AA5E3;
}
</style>
